import './InfoModal.less';

import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { SvgIcon } from '../../icons/SvgIcon';
import { isMobileChannel, motionOpacityVariant } from '../../common/util';
import { AnimatePresence, motion } from 'framer-motion';

export const InfoModal: FC<{ children: any; imgId; btnClasses?: string }> = ({ children, imgId, btnClasses }) => {
    const [visible, setVisible] = useState(false);
    const containerClass = 'disable-optimize-scroll';

    const disableClose = e => {
        e.stopPropagation();
    };

    const onOpen = e => {
        document.body.classList.add(containerClass);
        setVisible(true);
        e.stopPropagation();
    };

    const onClose = () => {
        document.body.classList.remove(containerClass);
        setTimeout(() => {
            setVisible(false);
        }, 0.3);
        // e.stopPropagation();
    };
    const mobileChannel = isMobileChannel();

    const ModalText: FC<{ otherClass?: string }> = ({ otherClass }) => {
        return (
            <div className={clsx('flex flex-col p-abs fs-13 modal-text-pos info-modal', otherClass)}>
                <div
                    onClick={disableClose}
                    className="text-left fw bg-white mx-5 mt-15 px-15 pb-20 br-radius-xs"
                    data-atid="info-modal"
                >
                    <div className="flex justify-end pt-15">
                        <button className="btn-no-pad filter-hover" onClick={onClose}>
                            <SvgIcon imgId="close" sizeX="12" sizeY="12" className="c-black-50" />
                        </button>
                    </div>
                    {children}
                </div>
            </div>
        );
    };

    return (
        <>
            {visible ? (
                <AnimatePresence>
                    <motion.div
                        key="backdrop"
                        variants={motionOpacityVariant}
                        initial="initial"
                        animate="enter"
                        exit="exit"
                        onClick={onClose}
                        className="p-fix info-modal-bgr"
                    />
                </AnimatePresence>
            ) : null}
            <button
                onClick={onOpen}
                className={clsx('p-rel', btnClasses, {
                    'info-modal bg-white br-radius-circle': visible
                })}
            >
                <SvgIcon imgId={imgId} sizeX="14" sizeY="14" />
                {visible && <span className="info-modal-arrow p-abs" />}
            </button>
            {visible && (
                <ModalText
                    otherClass={clsx({ 'modal-text-pos-l': !mobileChannel, 'info-icon-text': imgId === 'info-icon' })}
                />
            )}
        </>
    );
};
